import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    check
  ) => {
    const form = check.closest('form')
    const proto = one('select[name="new_protocol"]', form)
    const option = proto.options[proto.selectedIndex].value
    const port = one('input[name="new_port"]', form)
  
    if (port) {
      if (option === 'imap4') {
        port.value = (check.checked) ? 993 : 143
      } else if (option === 'pop3') {
        port.value =  (check.checked) ? 995 : 110
      }
    }
  }
})

export default ssl => {
  onInput.listen(ssl)
}
